import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { RequireAuth } from "@/components/Routing/RequireAuth";

import {
  canListProjectConnectionGroups,
  canListProjectConnections,
  canManageProjectConnectionGroups,
  canManageProjectConnections,
} from "./permissions";
import { projectConnectionsRoutes } from "./routes";

export const projectConnectionsRoute = [
  {
    path: projectConnectionsRoutes.list,
    lazy: async () => {
      const { ListConnectionsPage } = await import("./pages/list/ListConnectionsPage");

      return {
        element: (
          <RequireAuth permission={canListProjectConnections}>
            <ListConnectionsPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: projectConnectionsRoutes.create,
    lazy: async () => {
      const { CreateProjectConnectionPage } = await import("./pages/create-or-edit/CreateProjectConnectionPage");

      return {
        element: (
          <RequireAuth permission={canManageProjectConnections}>
            <CreateProjectConnectionPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: projectConnectionsRoutes.edit,
    lazy: async () => {
      const { EditProjectConnectionPage } = await import("./pages/create-or-edit/EditProjectConnectionPage");

      return {
        element: (
          <RequireAuth permission={canManageProjectConnections}>
            <EditProjectConnectionPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: projectConnectionsRoutes.listGroups,
    lazy: async () => {
      const { ListProjectConnectionGroupsPage } = await import("./pages/groups-list/ListProjectConnectionGroupsPage");

      return {
        element: (
          <RequireAuth permission={canListProjectConnectionGroups}>
            <ListProjectConnectionGroupsPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: projectConnectionsRoutes.createGroup,
    lazy: async () => {
      const { CreateProjectConnectionGroupPage } =
        await import("./pages/groups-create-or-edit/CreateProjectConnectionGroupPage");

      return {
        element: (
          <RequireAuth permission={canManageProjectConnectionGroups}>
            <CreateProjectConnectionGroupPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: projectConnectionsRoutes.editGroup,
    lazy: async () => {
      const { EditProjectConnectionGroupPage } =
        await import("./pages/groups-create-or-edit/EditProjectConnectionGroupPage");

      return {
        element: (
          <RequireAuth permission={canManageProjectConnectionGroups}>
            <EditProjectConnectionGroupPage />
          </RequireAuth>
        ),
      };
    },
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
